<i
  class="pi pi-shopping-cart"
  pBadge
  [value]="cartCount"
  severity="danger"
  style="font-size: 1.3rem; cursor: 'pointer'"
  p-text-secondary
  routerLink="/cart"
></i>
